import { gql } from "lib/apolloClient";

export const migrateTermAssociatedDataMutation = gql`
  mutation migrateTermData($input: ResolveProgressReportIssueInput!) {
    documentation {
      resolveProgressReportIssue(input: $input) {
        isSuccess
        errors
        __typename
      }
      __typename
    }
  }
`;
